<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>

export default {
  name: 'app',
}
</script>

<style>
body {
  margin:0;
  padding:0;
  height: 100%;
}
* {
  box-sizing: border-box;
}
html {
  height: 100%;
  font-family: sans-serif;
  background-image: linear-gradient(45deg, #263238, #37474f);
}
#app{
  height: 100%;
  position: relative;
}
</style>
